import { DateObject } from "@/classes";
import { ObjectPlugin } from "vue";

const datetimePlugin = () =>
  ({
    DateObject: DateObject,
  } as const);

export type DatetimePlugin = ReturnType<typeof datetimePlugin>;

export const $datetime: ObjectPlugin = {
  install: (app, _) => {
    app.config.globalProperties.$datetime = datetimePlugin();
  },
};

export default $datetime;
